import {ModalComponents} from 'constants/Modals';

import Button from 'components/Button/Button';
import Search from 'components/Search/Search';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {debounce} from 'lodash';
import {setModalAC} from 'store/modal/modalSlice';
import {setPageEditorFiltersAC} from 'store/pageEditors/pageEditorSlice';
import {GetPageEditorsDTO} from 'typescript/dto/pageEditorsDto';

interface IProps {
  searchValue?: string;
}

const NavbarContent = ({searchValue}: IProps) => {
  const dispatch = useSetGlobalState();

  const filters = useGlobalState((state) => state.pageEditors.filters);

  const handleInviteEditor = () => dispatch(setModalAC(ModalComponents.INVITE_PAGE_EDITOR));

  const debouncedSearch = debounce((filters: GetPageEditorsDTO, name: string) => {
    dispatch(setPageEditorFiltersAC({...filters, name}));
  }, 250);

  return (
    <div className="navbar-content">
      <Search
        value={searchValue}
        onChange={(value) => debouncedSearch(filters, value)}
        placeholder="Search Page Editors"
      />
      <Button variant="primary" onClick={handleInviteEditor}>
        Invite Editor
      </Button>
    </div>
  );
};

export default NavbarContent;
